module.exports = __webpack_public_path__ + "static/media/observablehq.cdf22504.png";